<script setup lang="ts">
import {Bar as BarChart} from 'vue-chartjs';
import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Filler,
    Legend,
    LinearScale,
    Title,
    Tooltip
} from "chart.js";
import {BackToBackWidget} from "@/laboratory/components/dashboard/dashboard";
import {computed} from "vue";
import {Widget} from "@/laboratory/components/dashboard/components/widget";
import ChartService from "@/laboratory/services/ChartService";

ChartJS.register(Title, Tooltip, Legend, Filler, BarElement, CategoryScale, LinearScale, ArcElement);

const props = defineProps<{
    widget: BackToBackWidget
}>();

const options = computed(() => {
    const allValues = props.widget.data.datasets.flatMap(dataset => dataset.values);
    const maxValue = Math.max(...allValues);

    return {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        interaction: {
            intersect: false
        },
        scales: {
            y: {
                stacked: true,
                reverse: true
            },
            x: {
                stacked: true,
                min: -maxValue - 1,
                max: maxValue + 1,
                ticks: {
                    callback: (value: number) => {
                        return Math.abs(value);
                    }
                }
            }
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = Math.abs(context.raw);

                        return `${context.dataset.label}: ${value}`;
                    }
                }
            }
        }
    };
});

const chartData = computed(() => {
    return {
        labels: props.widget.data.groups,
        datasets: props.widget.data.datasets.map((dataset, index) => {
            return {
                label: dataset.label,
                data: index === 0 ?
                    dataset.values.map(value => -value)
                    : dataset.values,
                backgroundColor: dataset.color || ChartService.getColor(index),
                barThickness: 20,
            };
        })
    };
});
</script>

<template>
  <Widget :widget="widget">
    <BarChart class="flex flex-1 min-h-[600px]" :data="chartData" :options="options as any" />
  </Widget>
</template>

<style scoped>

</style>
